import { LoginSeal } from "assets/js/Styles";
import React from "react";
import { Col, Row } from "reactstrap";
import styled from "styled-components";
import background from "assets/img/LoginHOR.png";

const Layout = styled(Row)`
  margin: 0;
  padding: 0;

  @media (max-width: 991.98px) {
    .p-0.col-lg-7 {
      display: none;
    }
  }
`;

const LoginContainer = styled.div`
  background: #f3f3f3 url(${background}) no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  padding-top: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 1rem 3rem;
`;

const FullLayout = ({ children }) => {
  return (
    <Layout>
      <Col
        className="p-0"
        lg="7"
        xl="8"
      >
        <LoginContainer>
          <LoginSeal />
        </LoginContainer>
      </Col>
      {children}
    </Layout>
  );
};

export default FullLayout;
